import { useState, useEffect } from "react";
import { supabase } from "../lib/supabase";

export const usePendingCompaniesCount = () => {
  const [count, setCount] = useState<number>(0);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchPendingCount = async () => {
      try {
        // Get count of companies with status "pending" only
        const { count: pendingCount, error: pendingError } = await supabase
          .from("company")
          .select("id", { count: "exact", head: true })
          .eq("status", "pending");

        if (pendingError) throw pendingError;

        setCount(pendingCount || 0);
      } catch (error) {
        console.error("Error fetching pending companies count:", error);
        setCount(0);
      } finally {
        setLoading(false);
      }
    };

    fetchPendingCount();

    // Set up polling to check for updates every 30 seconds
    const interval = setInterval(fetchPendingCount, 30000);

    return () => clearInterval(interval);
  }, []);

  return { count, loading };
};
